import axios from '@axios'

/**
 * ÍNDICE
 * {@link getExpenses} - Obtener gastos
 * {@link getExpense} - Obtener gasto
 * {@link addExpense} - Añadir gasto
 * {@link deleteExpense} - Eliminar gasto
 * {@link updateExpense} - Actualizar gasto
 */

export const getExpenses = function (queryParams) {
    try {
        return new Promise((resolve, reject) => {
        axios
            .get('/expenses', { params: queryParams })
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
    } catch (error) {
        return error
    }
    
    
}
export const getExpense = function ({ id }) {
    try {

        return new Promise((resolve, reject) => {
        axios
            .get(`/expenses/${id}`)
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
    } catch (error) {
        return error
    }
    
}
export const addExpense = function (data) {
    try {
        return new Promise((resolve, reject) => {
        axios
            .post(`/expenses`, data)
            .then(response => resolve(response))
            .catch(error => {reject(error); console.log(error)})
    })
    } catch (error) {

        console.log(error)
        return error
    }
}

export const deleteExpense = function ({ id }) {
    try {
        return new Promise((resolve, reject) => {
        axios
            .delete(`/expenses/${id}`)
            .then(response => resolve(response))
            .catch(error => reject(error))
    })
    } catch (error) {
        return error
    }
    
}
export const updateExpense = function (data) {
    try {
        return new Promise((resolve, reject) => {
        axios
            .put(`/expenses/${data.id}`, data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    } catch (error) {
        return error
    }
}

export const uploadExpense = function (file, id, type) {
    try {
        let formData = new FormData()
        formData.append('file', file)
        formData.append('id', id)
        formData.append('type', type)

        let headers = {
            "Content-Type": "multipart/form-data"
        }

        return new Promise((resolve, reject) => {
            axios.post('upload-expense', formData, headers)
                 .then(response => { console.log(response); return resolve(response.data) })
                 .catch(error => {console.log(error); return reject(error) })
        })
    } catch (error) {
        return error
    }
}

export const getExpenseUpload = function (id) {
    try {
        return new Promise((resolve, reject) => {
            axios.post('get-expense-upload', {id: id}, { responseType: 'arraybuffer' })
                 .then(response => { return resolve(response.data) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

export const deleteExpenseUpload = function (data) {
    try {
        return new Promise((resolve, reject) => {
            axios.post('delete-expense-upload', data)
                 .then(response => { return resolve(response.data) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}